// extracted by mini-css-extract-plugin
module.exports = {"price":"price-module--price--BMeb_","loadingPrice":"price-module--loadingPrice--3iuKf"};